// SEQ-169 hire comments: a view of the shared Supabase client typed for the
// tables the generic-comments migration adds.
//
// This is the same client instance and therefore the same session, cookies and
// RLS context. Only the schema type differs, because database.types.ts is
// generated from the live schema and cannot describe an unapplied migration.
//
// REMOVE once database.types.ts is regenerated: replace every entityCommentsDb
// call with the plain supabase client and delete this file together with
// src/types/entityComments.types.ts.

import type { SupabaseClient } from "@supabase/supabase-js";
import { supabase } from "./supabase";
import type { EntityCommentsDatabase } from "../types/entityComments.types";

export const entityCommentsDb = supabase as unknown as SupabaseClient<
  EntityCommentsDatabase
>;
